// Shared custom-emoji upload helpers (used by the Add Emoji modal; formerly
// lived in the Custom Emojis settings panel, which has been removed).
import { filterAutoFilenameTokens } from './filenameUtils';
import { getMetaContent } from './meta';

export const EMOJI_CONTENT_TYPES = JSON.parse(getMetaContent('emoji:custom_content_types') || '[]');

export const normalizeShortcode = (value) => {
  if (!value) return '';
  let s = String(value).trim();
  if (!s) return '';
  s = s.toLowerCase();
  s = s.replace(/\s+/g, '-');
  s = s.replace(/[^a-z0-9_-]/g, '');
  s = s.replace(/-+/g, '-').replace(/_+/g, '_');
  if (/[a-z0-9]/.test(s)) {
    // strip leading/trailing separators only when alphanumerics are present
    s = s.replace(/^[-_]+|[-_]+$/g, '');
  } else if (!/^[_-]$/.test(s)) {
    // reject multi-char separator-only strings (e.g. _-, -_-) — backend normalises these to blank
    return '';
  }
  return s;
};

export const deriveShortcodeFromFilename = (name) => {
  return normalizeShortcode(filterAutoFilenameTokens(name));
};
